import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './css/border.scss';
import './css/color.scss';
import './css/font.scss';
import './css/image.scss';
import './css/layout.scss';
import './css/margin.scss';
import './css/padding.scss';
import './css/position.scss';
//import * as Sentry from "@sentry/react";
//import { Integrations } from "@sentry/tracing";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


// Sentry.init({
//     dsn: "https://2648b0731f6f431bb83919e4f1c4b136@opentracking.zpapps.vn/16",
//     integrations: [
//         new Integrations.BrowserTracing(),
//     ],
//     environment: window['runtime_configs'].REACT_APP_ENV,
//     // We recommend adjusting this value in production, or using tracesSampler
//     // for finer control
//     tracesSampleRate: 1.0,
// });

ReactDOM.render(<App/>, document.getElementById('root'));
serviceWorker.unregister();